import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import theme from "./theme/theme";
import { ThemeProvider } from "@mui/material/styles";

// Create a root element using React 18's createRoot API
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
